// --- START PATCH: 404 Not Found page ---
import { Link } from "react-router-dom";
import { Button } from "@/lib/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent } from "@/lib/components/ui/card";
import { Home, Search } from "lucide-react";

const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-center text-2xl">404 - Page Not Found</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex justify-center">
            <Search className="h-24 w-24 text-muted-foreground opacity-50" />
          </div>
          <p className="text-center text-muted-foreground">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild className="rounded-full">
              <Link to="/">
                <Home className="mr-2 h-4 w-4" />
                Go Home
              </Link>
            </Button>
            <Button asChild variant="outline" className="rounded-full">
              <Link to="/contact">Contact Support</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
// --- END PATCH: 404 Not Found page ---
